<template>
    <div>
        <v-container fluid>
            <v-banner single-line sticky>
                <v-alert
                    color="blue-grey darken-3"
                    dense
                    border="bottom"
                    type="primary"
                    icon="mdi-information"
                >
                    <v-row no-gutters>
                        <v-col cols="4">OPEN NEW CASE</v-col>
                        <v-col cols="4" class="text-center">
                            <v-chip
                                v-if="showpartners != ''"
                                class="orange darken-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showpartners }}</h3>
                            </v-chip>
                            <v-chip
                                v-if="showproject != ''"
                                class="ml-2 orange darken-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showproject }}</h3>
                            </v-chip>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn
                                v-if="!visible"
                                class="ma-0"
                                @click="back()"
                                tile
                                color="cyan darken-1"
                                dark
                                small
                                >Back</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-alert>
            </v-banner>
            <v-row v-if="visible">
                <v-col cols="12" sm="4">
                    <v-card
                        @click="getPartner()"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h1>CHOOSE PROJECT</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="2"></v-col>
                <!-- <v-col cols="8" sm="4">
          <v-file-input
            v-model="files"
            color="blue darken-4"
            counter
            label="อัพโหลดไฟล์ case"
            multiple
            small-chips
            placeholder="Select your files"
            prepend-icon="mdi-paperclip"
            :show-size="1000"
            @change="onFileSelected"
          ></v-file-input>
        </v-col>
        <v-col cols="4" sm="2">
          <v-btn
            :loading="loading2"
            :disabled="loading2"
            color="blue-grey"
            class="white--text"
            fab
            @click="UploadFiles()"
          >
            <v-icon dark>mdi-file-upload-outline</v-icon>
          </v-btn>
        </v-col>-->
                <v-col :cols="12" v-if="data_case.total > 0">
                    <v-alert
                        dense
                        border="bottom"
                        type="primary"
                        icon="mdi-information"
                        >CASE TODAY</v-alert
                    >
                    <table-view-case
                        :casetab="casetab"
                        :condition="condition"
                        :data_case="data_case"
                    />
                    <div class="text-center pa-5">
                        <v-pagination
                            @input="onPageChange"
                            v-model="pagination.current"
                            :length="data_case.last_page"
                            circle
                        ></v-pagination>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="!visiblepartner">
                <v-col v-for="(item, idx) in partners" :key="idx" :cols="3">
                    <v-card
                        @click="getProject(item.partner_id, item.partner_name)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h1>{{ item.partner_name }}</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="!visibleproject">
                <v-col v-for="(item, idx) in projects" :key="idx" :cols="3">
                    <v-card
                        @click="selectProject(item.project_id)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h3>{{ item.project_name }}</h3>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="!visibleproblem">
                <v-col v-for="(item, idx) in problemgroup" :key="idx" :cols="3">
                    <v-card
                        @click="selectProblem(item.problem_group_id)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h3>{{ item.problem_group_name }}</h3>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <div v-if="!visiblecase">
                <v-card>
                    <v-form ref="form" v-model="information.valid">
                        <v-information
                            :condition="condition"
                            :information="information"
                        />
                        <!-- <case-information
              :condition="condition"
              :information="information"
            />
            <product-information
              :condition="condition"
              :information="information"
            />
            <customer-information
              :condition="condition"
              :information="information"
            /> -->
                        <engineer-information
                            @showform="validateform()"
                            :condition="condition"
                            :information="information"
                        />
                        <!-- เลือกประเภท PARTS เมื่อมี HP Case ID และยังไม่เลือก -->
                        <v-row
                            v-if="information.case_hp && !part_type"
                            justify="center"
                            class="my-4"
                        >
                            <v-col cols="12" class="text-center mb-2">
                                <span class="subtitle-1 font-weight-bold">กรุณาเลือก  Type PARTS RECOMMEND</span>
                            </v-col>
                            <v-col cols="12" sm="4" class="text-center">
                                <v-btn
                                    large
                                    color="teal darken-1"
                                    dark
                                    @click="part_type = 'local'; information.skip_ismart = ''"
                                >
                                    <v-icon left>mdi-check-circle</v-icon>Local Part
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="4" class="text-center">
                                <v-btn
                                    large
                                    color="indigo darken-1"
                                    dark
                                    @click="getHpPart()"
                                >
                                    <v-icon left>mdi-barcode</v-icon>HP Part
                                </v-btn>
                            </v-col>
                        </v-row>

                        <part-information
                            v-if="!information.case_hp || part_type === 'local'"
                            key="part-normal"
                            ref="partinfor"
                            :condition="condition"
                            :information="information"
                        />
                        <hpi-part-information
                            v-if="information.case_hp && part_type === 'hp'"
                            key="part-hpi"
                            :condition="condition"
                            :information="information"
                        />
                    </v-form>
                    <!-- <log-information
                        :condition="condition"
                        :information="information"
          />-->
                    <v-row v-if="information.case_hp && part_type === 'hp'" justify="center" class="mb-2">
                        <v-col cols="10" md="4" class="text-center">
                            <v-checkbox
                                v-model="information.skip_ismart"
                                false-value="N"
                                true-value="Y"
                                label="ช่างไม่ต้องเปิด EEG"
                                disabled
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn
                            :disabled="!information.valid || isSaving"
                            @click="checktoner()"
                            class="ma-4"
                            tile
                            color="success"
                        >
                            <v-icon left>mdi-content-save</v-icon>Save
                        </v-btn>
<!-- <v-btn class="ma-4" tile color="warning">
              <v-icon left>mdi-close-octagon</v-icon>Cancel
            </v-btn>-->
                    </v-row>
                </v-card>
            </div>
        </v-container>

        <!-- Save Result Modal -->
        <v-dialog v-model="saveResultDialog" max-width="860px" persistent>
            <v-card class="save-result-card">
                <!-- Header -->
                <div class="save-result-header">
                    <div class="save-result-icon-wrap">
                        <v-icon size="48" color="white">mdi-check-circle</v-icon>
                    </div>
                    <div class="save-result-header-text">
                        <div class="save-result-title">บันทึกเคสสำเร็จ</div>
                    </div>
                </div>

                <!-- Case Info Chips -->
                <div class="save-result-info">
                    <div class="save-result-info-box">
                        <div class="save-result-info-label">Case ID</div>
                        <div class="save-result-info-value">{{ saveResult.case_id }}</div>
                    </div>
                    <v-divider vertical class="mx-4"></v-divider>
                    <div class="save-result-info-box">
                        <div class="save-result-info-label">Subcase</div>
                        <div class="save-result-info-value"># {{ saveResult.subcase }}</div>
                    </div>
                    <v-divider vertical class="mx-4"></v-divider>
                    <div class="save-result-info-box">
                        <div class="save-result-info-label">Parts</div>
                        <div class="save-result-info-value">{{ saveResult.parts ? saveResult.parts.length : 0 }} รายการ</div>
                    </div>
                </div>

                <v-card-text class="px-6 pb-2">
                    <!-- Parts Table -->
                    <div v-if="saveResult.parts && saveResult.parts.length">
                        <div class="save-result-parts-title">
                            <v-icon small class="mr-1" color="blue darken-2">mdi-package-variant</v-icon>
                            Parts Recommend
                        </div>
                        <v-simple-table class="save-result-table">
                            <thead>
                                <tr>
                                    <th style="width:150px">Part Number</th>
                                    <th>Description</th>
                                    <th style="width:160px">LPN</th>
                                    <th style="width:160px">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, i) in saveResult.parts" :key="i"
                                    :class="p.status !== 'Recommended' ? 'save-result-row-warn' : ''">
                                    <td class="font-weight-medium">{{ p.part_number }}</td>
                                    <td class="grey--text text--darken-2">{{ p.part_desc }}</td>
                                    <td>
                                        <span v-if="p.lpn" class="save-result-lpn">{{ p.lpn }}</span>
                                        <span v-else class="grey--text">—</span>
                                    </td>
                                    <td>
                                        <div class="d-flex align-center">
                                            <v-icon small class="mr-1"
                                                :color="p.status === 'Recommended' ? 'green darken-1' : 'red darken-1'">
                                                {{ p.status === 'Recommended' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                                            </v-icon>
                                            <span :class="p.status === 'Recommended' ? 'green--text text--darken-1' : 'red--text text--darken-1'"
                                                class="font-weight-medium caption">
                                                {{ p.status }}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <div v-else class="save-result-noparts">
                        <v-icon color="grey lighten-1" size="32">mdi-package-variant-closed</v-icon>
                        <span class="ml-2 grey--text">ไม่มีรายการอะไหล่</span>
                    </div>
                </v-card-text>

                <!-- Actions -->
                <v-card-actions class="px-6 pt-3 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn outlined color="grey darken-1" class="mr-2" @click="afterSaveConfirm(false)">
                        <v-icon left small>mdi-close</v-icon>ปิด
                    </v-btn>
                    <v-btn color="primary" elevation="0" @click="afterSaveConfirm(true)">
                        <v-icon left small>mdi-plus-circle</v-icon>เปิดเคสต่อใน Project เดิม
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import firebaseApp from "../../../firebase"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import EngineerNewInformation from "../components/EngineerNewInformation"
import PartInformation from "../components/PartInformationNew.vue"
import HpiPartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"

import Information from "../components/Information"

export default {
    components: {
        "table-view-case": TableViewCase,
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "hpi-part-information": HpiPartInformation,
        "log-information": LogInformation,
        "v-information": Information,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    data() {
        return {
            isSaving: false,
            saveResultDialog: false,
            saveResult: { case_id: null, subcase: null, parts: [] },
            part_type: "",
            casetab: false,
            condition: {
                team: "NONHP",
                status: "ViewDetail",
            },
            information: {
                case_title: "",
                case_type: "",
                case_csr: "",
                case_problem_type: "",
                case_hp: "",
                skip_ismart: "",
                case_sla: "",
                case_refer: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
                clearbyphone: false,
                sla_new: [],
                case_create_date: "",
                case_create_time: "",
                booking_case_number: "",
            },
            defaultInformation: {
                case_title: "",
                case_type: "",
                case_csr: "",
                case_problem_type: "",
                case_hp: "",
                skip_ismart: "",
                case_sla: "",
                case_refer: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
                clearbyphone: false,
                booking_case_number: "",
            },
            partners: [],
            company: "",
            visible: true,
            projects: [],
            problemgroup: [],
            visibleproblem: true,
            visibleproject: true,
            visiblepartner: true,
            selectedproject: [],
            visiblecase: true,
            showproject: "",
            showpartners: "",
            data_case: [],
            pagination: {
                current: 1,
            },
        }
    },
    mounted() {
        this.getOwnerTodayCase()
    },
    watch: {
        async "information.case_problem_type"(val) {
            if (!val || !this.information.project_id) return
            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/booking-casenumber`
                const options = { headers: { Authorization: "Bearer " + localStorage.token } }
                const { data } = await axios.post(
                    url,
                    { project_id: this.information.project_id, case_problem_type: val },
                    options
                )
                // console.log("[booking-casenumber] response:", data)
                this.information.booking_case_number = data.next_case_id
            } catch (error) {
                console.log("[booking-casenumber] error:", error)
            }
        },
        "information.case_hp"(val, oldVal) {
            if (!val && !!oldVal) {
                this.information.part = []
            }
            this.part_type = ""
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        validateform() {
            this.$refs.form.validate()
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getOwnerTodayCase()
        },
        async getOwnerTodayCase() {
            this.casetab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/owner-case-today?page=${this.pagination.current}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.casetab = true
            } catch (error) {
                console.log(error)
            }
        },
        back() {
            if (this.visiblepartner === false) {
                this.visible = true
                this.visiblepartner = true
            } else if (this.visibleproject === false) {
                this.visiblepartner = false
                this.visibleproject = true
                this.visibleproblem = true
            } else if (
                this.visiblepartner === true &&
                this.visibleproject === true &&
                this.visible === false
            ) {
                this.visiblepartner = true
                this.visibleproject = false
                this.visibleproblem = true
                this.visiblecase = true
                this.showpartners = ""
                this.showproject = ""
                this.information = { ...this.defaultInformation }
            }
        },
        async getPartner() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/getpartners`
            try {
                const { data } = await axios.get(`${url}`)
                this.partners = data

                this.visible = false
                this.visiblepartner = false
            } catch (error) {
                console.log(error)
            }

            this.company = val
        },

        async getProject(partner, partner_name) {
            this.showpartners = partner_name
            this.partners.map((each) => {
                if (each.partner_id == partner) {
                    this.projects = each.projects
                }
            })

            this.visiblepartner = true
            this.visibleproject = false
        },
        selectProblem(problem_group_id) {
            this.information.problem_group_id = problem_group_id
            this.visiblecase = false
            this.visibleproblem = true
        },
        async selectProject(project_id) {
            this.selectedproject = project_id
            this.visibleproject = true
            this.information.project_id = project_id

            this.projects.map((each) => {
                if (project_id == each.project_id) {
                    this.problemgroup = each.problem_group
                }
            })
            if (this.problemgroup.length == 0) {
                this.information.problem_group_id = 0
                this.visiblecase = false
            } else {
                this.visibleproblem = false
            }

            this.projects.map((each) => {
                if (each.project_id == project_id) {
                    this.condition.project = each.project_name
                    this.showproject = each.project_name
                    this.information.sla_new = [
                        ...each.sla.map((res) => {
                            return res.sla
                        }),
                    ]
                }
            })
            // this.information.problem_group_id = 4;
            // this.visiblecase = false;
        },
        checktoner() {
            if (
                this.information.part.length == 1 &&
                this.information.category_id == "3" &&
                this.information.case_problem_type != "3" &&
                this.information.project_id == "54"
            ) {
                this.$swal({
                    title: "problem type ไม่ใช่ toner ?",
                    text: "",
                    icon: "warning",
                    buttons: true,
                    primaryMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        this.saveCase()
                    } else {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        })
                    }
                })
            } else {
                this.saveCase()
            }
        },
        async getHpPart() {
            const case_id = this.information.case_hp
            const type =
                case_id[0] == "5" &&
                case_id.length == 10 &&
                case_id.substring(0, 2) != "54"
                    ? "CDAX"
                    : case_id.substring(0, 2) == "54"
                    ? "HPE"
                    : "SRFR"
            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/hp/checkcase`
                const { data } = await axios.post(url, {
                    case_id,
                    ponumber: "",
                    wonumber: "",
                    type,
                })
                console.log("[getHpPart] data:", data)
                this.information.part =
                    data.parts && data.parts.length > 0 ? [...data.parts] : []
                this.part_type = "hp"
                this.information.skip_ismart = "Y"
            } catch (error) {
                console.log(error.message)
            }
        },
        async saveCase() {
            if (this.isSaving) return 
            this.isSaving = true
            this.defaultInformation.problem_type = [
                ...(this.information.problem_type || []),
            ]
            if (this.information.engineer == "ZONE") {
                this.information.dateonsite = ""
            }
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time

            this.information.case_create_datetime =
                this.information.case_create_date +
                " " +
                this.information.case_create_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/newcase`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            console.log("[saveCase] payload:", JSON.parse(JSON.stringify(this.information)))
            try {
                this.mutateIsLoading()
                let { data, status } = await axios
                    .post(url, this.information, options)
                    .catch(function(error) {
                        swal({
                            title: `Error Message : ${error}`,
                            icon: "error",
                            button: "OK",
                        })
                    })
                this.mutateIsLoading()
                console.log("[saveCase] status:", status, "data:", data)
                if ((status === 200 || status === 201) && data && data.case_id) {
                    this.saveResult = {
                        case_id: data.case_id,
                        subcase: data.subcase,
                        parts: data.parts || [],
                    }
                    this.saveResultDialog = true
                }
            } catch (error) {
                console.log(error.message)
            }
            this.isSaving = false
            //   var contactRef = firebaseApp.database().ref(`contacts/${this.information.ReferCase}`)
            //   contactRef.set({
            //         casetitle: this.information.casetitle,
            //         jobtype: this.information.jobtype,
            //         proptype : this.information.Probtype
            //   })
        },
afterSaveConfirm(continueProject) {
            this.saveResultDialog = false
            if (continueProject) {
                this.information = {
                    project_id: this.selectedproject,
                    dateonsite: "",
                    ...this.defaultInformation,
                }
                window.scrollTo(0, 0)
                this.information.case_type = "Onsite Repair"
                this.information.case_csr = "C"
                this.information.case_sla = "NBD"
                this.$refs.partinfor.delpart()
            } else {
                this.visible = true
                this.visiblepartner = true
                this.visibleproject = true
                this.visiblecase = true
                this.showproject = ""
                this.information = { ...this.defaultInformation }
                this.getOwnerTodayCase()
            }
        },
    },
}
</script>

<style>
.v-banner__text {
    width: 1150px;
}

.save-result-card {
    border-radius: 12px !important;
    overflow: hidden;
}

.save-result-header {
    background: linear-gradient(135deg, #2e7d32, #43a047);
    display: flex;
    align-items: center;
    padding: 20px 28px;
    gap: 16px;
}

.save-result-icon-wrap {
    background: rgba(255,255,255,0.15);
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.save-result-header-text {
    color: white;
}

.save-result-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
}

.save-result-subtitle {
    font-size: 13px;
    opacity: 0.8;
    margin-top: 2px;
}

.save-result-info {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    padding: 16px 28px;
    border-bottom: 1px solid #e0e0e0;
}

.save-result-info-box {
    text-align: center;
    flex: 1;
}

.save-result-info-label {
    font-size: 11px;
    color: #9e9e9e;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-weight: 600;
}

.save-result-info-value {
    font-size: 22px;
    font-weight: 700;
    color: #212121;
    margin-top: 2px;
}

.save-result-parts-title {
    font-size: 13px;
    font-weight: 600;
    color: #1565c0;
    margin-bottom: 10px;
    margin-top: 16px;
}

.save-result-table {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
}

.save-result-table thead tr {
    background: #f5f5f5;
}

.save-result-table thead th {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #616161 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.save-result-row-warn {
    background: #f9dbdd !important;
}

.save-result-row-warn td {
    border-bottom: 1px solid #ef9a9a !important;
}

.save-result-lpn {
    font-family: monospace;
    font-size: 12px;
    background: #e3f2fd;
    color: #1565c0;
    padding: 2px 6px;
    border-radius: 4px;
}

.save-result-noparts {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
}
</style>
